 import './App.css';
 import React, { useState, useEffect} from 'react';
 import playerData from './Data/data.json';
 import Player from './components/Player/Player';
 import '../node_modules/bootstrap/dist/css/bootstrap.min.css';  //import bootstrap.
 import PlayerSelection from './components/PlayerSelection/PlayerSelection';

function App() {
  const [player,setPlayer]=useState([]); //This state use receive data from the json file.
  const [selectPlayer,setSelectPlayer]=useState([]);  //This state use to cart the player.
  useEffect(() =>{ 
  setPlayer(playerData)
  } ,[])
  //Handle all selected player for the cart.
  const addEventHandler =(player)=>{
    const newPlayer =[...selectPlayer,player];
    setSelectPlayer(newPlayer);
  }
  return (
    <div className="App">
    {/* Using bootstrap class. */}
   <h2 className="text-center mt-5 pb-3">Total Player: {player.length}</h2>
   <PlayerSelection selectPlayer={selectPlayer}></PlayerSelection>
    
   {/* Mapping the player list from the player information and pass player data and also pass a event handler*/}
   <div className="player-formate-design">
   {
    player.map(player =><Player player={player} key={player.id} addEventHandler={addEventHandler}></Player> )
   }
   </div>
 
    </div>
  );
}

export default App;
